module.exports = __webpack_public_path__ + "static/media/price_svg.e715625c.svg";